import o from "../ethereum/binanceChain.mjs";
import a from "../ethereum/metaMask.mjs";
import p from "../ethereum/walletConnect.mjs";
import { WalletType as r } from "../types/index.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "./provider.mjs";
import "@deorderbook/contracts";
import { SubgraphURLEnum as b, getSubgraphEndPoint as d } from "./subgraph.mjs";
let e;
const k = (t) => {
  switch (t.type) {
    case r.MetaMask:
      e = new a();
      break;
    case r.WalletConnect:
      e = new p({
        type: t.type,
        provider: t.provider
      });
      break;
    case r.BinanceWallet:
      e = new o();
      break;
    default:
      throw new Error(`wallet type '${t.type}' not supported`);
  }
  return e;
};
export {
  b as SubgraphURLEnum,
  d as getSubgraphEndPoint,
  k as initWalletStore,
  e as wallet
};
//# sourceMappingURL=index.mjs.map
